import { gql } from '@apollo/client';

export const SET_NAS_CONFIG = gql`
  mutation SetNasConfig($host: String!, $username: String!, $password: String!, $basePath: String) {
    setNasConfig(host: $host, username: $username, password: $password, basePath: $basePath) {
      configured
      host
      basePath
      updatedAt
      updatedByName
    }
  }
`;

export const UNSET_NAS_CONFIG = gql`
  mutation UnsetNasConfig {
    unsetNasConfig
  }
`;

export const TEST_NAS_CONNECTION = gql`
  mutation TestNasConnection($host: String!, $username: String!, $password: String!, $basePath: String) {
    testNasConnection(host: $host, username: $username, password: $password, basePath: $basePath) {
      success
      latencyMs
      error
      rootItems
    }
  }
`;

export const TEST_CURRENT_NAS_CONNECTION = gql`
  mutation TestCurrentNasConnection {
    testCurrentNasConnection {
      success
      latencyMs
      error
      rootItems
    }
  }
`;

export const ATTACH_NAS_MEDIA_TO_USER = gql`
  mutation AttachNasMediaToUser($userId: Int!, $nasPath: String!, $displayName: String) {
    attachNasMediaToUser(userId: $userId, nasPath: $nasPath, displayName: $displayName) {
      id
      displayName
      mime
      size
      attachedAt
      attachedByName
    }
  }
`;

export const DETACH_NAS_MEDIA_FROM_USER = gql`
  mutation DetachNasMediaFromUser($nasMediaId: String!) {
    detachNasMediaFromUser(nasMediaId: $nasMediaId)
  }
`;

export const SCAN_NAS_FOLDER = gql`
  mutation ScanNasFolder($path: String!) {
    scanNasFolder(path: $path) {
      nasPath
      displayName
      mime
      size
      suggestedUserId
      suggestedUserFirstName
      suggestedUserLastName
      matchType
      thumbnailUrl
      previewUrl
    }
  }
`;

export const CONFIRM_NAS_MEDIA_SUGGESTIONS = gql`
  mutation ConfirmNasMediaSuggestions($suggestions: [NasMediaSuggestionInput!]!) {
    confirmNasMediaSuggestions(suggestions: $suggestions) {
      attached
    }
  }
`;

export const SET_USER_NAS_BROWSE_ACCESS = gql`
  mutation SetUserNasBrowseAccess($userId: Int!, $canBrowse: Boolean!) {
    setUserNasBrowseAccess(userId: $userId, canBrowse: $canBrowse) {
      userId
      canBrowseNas
    }
  }
`;
